import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import { motion } from "framer-motion";

export default function About() {
  return (
    <>

      <Helmet>
        <title>About Us – ApnaWebX | Website Development & Digital Service Experts</title>
        <meta name="description" content="Learn about ApnaWebX, a trusted website development & digital service company helping brands build strong online presence with modern design & smart technologies." />
        <meta name="keywords" content="about apnawebx, best web development company, digital solutions team, website experts" />

        <link rel="canonical" href="https://apnawebx.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="About ApnaWebX – Web Development Experts" />
        <meta property="og:description" content="We build powerful digital solutions for businesses across India." />
        <meta property="og:image" content="https://apnawebx.com/images/about-og.jpg" />
        <meta property="og:url" content="https://apnawebx.com/about" />



        <script type="application/ld+json">
          {`  {
          "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ApnaWebX",
        "url": "https://apnawebx.com",
        "logo": "https://apnawebx.com/images/logo/apnawebxlogo.png",
        "description": "We provide website development, branding, SEO, WhatsApp automation & digital services.",
        "address": {
          "@type": "PostalAddress",
        "addressLocality": "Ahmedabad",
        "addressRegion": "Gujarat",
        "addressCountry": "IN"
  },
        "sameAs": [
        "https://www.instagram.com/apnawebx",
        "https://www.facebook.com/apnawebx"
        ]
}
        `}
        </script>

      </Helmet>



      {/* BREADCRUMB */}
      <Breadcrumb
        title="About Us"
        paths={[
          { label: "About Us", link: null }
        ]}
      />

      {/* ABOUT MAIN CONTENT */}
      <section className="max-w-7xl mx-auto py-16">

        {/* TOP ABOUT SECTION */}
        <div className="grid md:grid-cols-2 gap-12 items-center px-6">

          {/* LEFT TEXT */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl text-[#855109]"> About <span className="text-4xl font-bold">ABOUT APNAWEBX</span> </h1>


            <p className="mt-5 text-lg text-gray-700 leading-relaxed ">
              ApnaWebX is a professional IT solutions agency specializing in website development, branding, SEO, digital marketing, and WhatsApp automation.
              Our mission is to help businesses grow with high-quality websites and impactful digital strategies.We are Website developer in Odhav Ahmedabad.
            </p>

            <p className="mt-4 text-gray-600 leading-relaxed ">
              With a team of creative designers, developers, and branding
              experts, we transform your ideas into impactful digital products.
              Our goal is simple — deliver high-quality work that drives results. We provide affordable website design in Ahmedabad.
            </p>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="/images/about/hero-about.jpg"
              className="rounded-2xl shadow-xl object-cover h-[300px] md:h-[500px]"
              alt="ApnaWebX"
              loading="lazy"
            />
          </motion.div>
        </div>

        {/* STATS SECTION */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 text-center px-6">
          {[
            { number: "70+", label: "Happy Clients" },
            { number: "70+", label: "Projects Completed" },
            { number: "5+", label: "Years Experience" },
            { number: "30+", label: "Industries Served" }
          ].map((stat, index) => (
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              key={index} className="bg-[#fff7ef] p-6 rounded-xl shadow-sm border border-[#eed7bc]">
              <h3 className="text-3xl font-extrabold text-[#855109]">{stat.number}</h3>
              <p className="mt-1 text-gray-700 font-medium">{stat.label}</p>
            </motion.div>
          ))}
        </div>

        {/* MISSION & VISION */}
        <div className="mt-20 grid md:grid-cols-2 gap-14 px-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-[#fff7ef] p-10 rounded-2xl border border-[#eed7bc] shadow-lg">
            <h2 className="text-3xl font-bold text-[#855109]">Our Mission</h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
              To make digital transformation affordable and accessible for every business by delivering innovative, reliable, and result-oriented IT solutions.

            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }} className="bg-[#fff7ef] p-10 rounded-2xl border border-[#eed7bc] shadow-lg">
            <h2 className="text-3xl font-bold text-[#855109]">Our Vision</h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
              To become a leading digital solutions provider known for creativity, quality, and customer satisfaction.
            </p>
          </motion.div>
        </div>


        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }} >
          <section className=" mx-auto px-6 py-10 md:py-16 space-y-6 text-[17px] leading-relaxed text-gray-700">

            <p>
              ApnaWebX is a full-service digital agency committed to helping businesses
              establish a powerful presence in today’s competitive online world. We
              specialise in delivering high-quality websites, mobile applications, brand
              identity solutions, and automation services that enable organisations to
              operate smarter and grow faster. Our approach is centred on understanding
              client needs and transforming ideas into scalable digital experiences.
            </p>

            <p>
              Over the years, we have partnered with businesses across multiple industries,
              offering customised solutions aligned with their long-term goals. Our
              team brings together creative designers, experienced developers, and
              digital strategists who work collaboratively to ensure every project meets
              the highest standards of design, performance, and reliability. At ApnaWebX,
              we believe that great design and powerful technology can significantly impact
              business success.
            </p>


            <div>

              <h2 className="text-2xl font-semibold text-[#855109]">
                What Makes Us Different?  </h2>

              <ul className="list-disc ml-8">


                <li> Modern and clean UI/UX</li>

                <li>  Fast development time</li>

                <li> SEO-ready websites</li>

                <li> Customer-focused approach</li>

                <li>Transparent pricing</li>
              </ul>
            </div>


          </section>
        </motion.div>


        {/* ===================== WHY CHOOSE US ===================== */}
        <section className="py-20 bg-gray-50 relative overflow-hidden">

          {/* Background Decorative Blurs */}
          <div className="absolute top-10 left-10 w-40 h-40 bg-[#855109]/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-52 h-52 bg-[#6b4107]/20 rounded-full blur-3xl"></div>

          <div className="relative max-w-7xl mx-auto px-8 text-center">

            {/* Section Heading */}
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="text-4xl md:text-5xl font-montserrat font-extrabold text-[#855109]"
            >
              Why Choose ApnaWebX for Your Website?
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-gray-700 mt-4 text-lg  max-w-2xl mx-auto"
            >
              We help businesses build a strong digital presence using modern design, smart technology, and results-driven digital strategies.
            </motion.p>

            {/* Cards */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 mt-14">

              {/* CARD 1 */}
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                whileHover={{ scale: 1.05 }}
                className="p-10 bg-white/80 backdrop-blur-xl border border-gray-200 shadow-xl rounded-2xl hover:shadow-2xl transition-all  bg-cover bg-center bg-no-repeat relative"
                style={{ backgroundImage: "url('/images/home/service-bg.jpg')" }}
              >
                {/* OVERLAY */}
                <div className="absolute inset-0 bg-[#855109]/30 backdrop-blur-sm rounded-2xl"></div>
                <div className="relative z-10 w-14 h-14 mx-auto bg-[#855109]/15 text-[#855109] rounded-2xl flex items-center justify-center text-3xl shadow-md">
                  ⭐
                </div>
                <h3 className="relative z-10 text-2xl font-montserrat font-bold mt-4 text-[#855109] bg-white">High-quality professional designs</h3>
                <p className="relative z-10 text-white text-base mt-2 ">
                  Premium modern designs, optimized performance, and attention to detail.
                </p>
              </motion.div>

              {/* CARD 2 */}
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                whileHover={{ scale: 1.05 }}
                className="p-10 bg-white/80 backdrop-blur-xl border border-gray-200 shadow-xl rounded-2xl hover:shadow-2xl transition-all bg-cover bg-center bg-no-repeat relative"
                style={{ backgroundImage: "url('/images/home/service-bg.jpg')" }}
              >
                {/* OVERLAY */}
                <div className="absolute inset-0 bg-[#855109]/30 backdrop-blur-sm rounded-2xl"></div>
                <div className="relative z-10 w-14 h-14 mx-auto bg-[#855109]/15 text-[#855109] rounded-xl flex items-center justify-center text-3xl shadow-md">
                  ⚡
                </div>
                <h3 className="relative z-10 text-2xl font-montserrat font-bold mt-4 text-[#855109] bg-white">Fast-loading, SEO-friendly websites</h3>
                <p className="relative z-10 text-white text-base mt-2 ">
                  Efficient development process ensuring your project launches on time.
                </p>
              </motion.div>

              {/* CARD 3 */}
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                whileHover={{ scale: 1.05 }}
                className="p-10 bg-white/80 backdrop-blur-xl border border-gray-200 shadow-xl rounded-2xl hover:shadow-2xl transition-all bg-cover bg-center bg-no-repeat relative"
                style={{ backgroundImage: "url('/images/home/service-bg.jpg')" }}
              >
                {/* OVERLAY */}
                <div className="absolute inset-0 bg-[#855109]/30 backdrop-blur-sm rounded-2xl"></div>
                <div className="relative z-10 w-14 h-14 mx-auto bg-[#855109]/15 text-[#855109] rounded-xl flex items-center justify-center text-3xl shadow-md">
                  💰
                </div>
                <h3 className="relative z-10 text-2xl font-montserrat font-bold mt-4 text-[#855109] bg-white">Branding and digital growth services</h3>
                <p className="relative z-10 text-white text-base mt-2 ">
                  Build a strong brand identity with logos, color schemes, typography, and complete brand design.
                </p>
              </motion.div>

            </div>
          </div>
        </section>


        {/* CTA SECTION */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-14 bg-[#855109] text-white mx-6 p-12 rounded-3xl shadow-xl text-center">
          <h2 className="text-4xl font-bold">Ready to Build Your Website?</h2>
          <p className="mt-3 text-white/80 text-lg">
            Get a free consultation and start your digital growth journey today.
          </p>

          <div className="mt-6">
            <a
              href="/contact"
              className="px-6 py-3 bg-white text-[#855109] font-bold rounded-xl shadow-lg hover:bg-[#f5e1c8] transition"
            >
              Get Free Quote
            </a>
          </div>
        </motion.div>

      </section >
    </>
  );
}
